// extracted by mini-css-extract-plugin
export default {"container":"AccountSetting_container__u-D-T","content":"AccountSetting_content__M2wAh","bottomBox":"AccountSetting_bottomBox__p+j-s"};